export default {
  namespaced: true,
  state: {
    currentCompany: JSON.parse(localStorage.getItem('oa_company') || 'null'),
    companies: []
  },
  mutations: {
    SET_COMPANIES(state, list) {
      state.companies = list
    },
    SET_CURRENT(state, company) {
      state.currentCompany = company
      localStorage.setItem('oa_company', JSON.stringify(company))
    }
  },
  getters: {
    currentId: state => state.currentCompany ? state.currentCompany.id : null,
    currentName: state => state.currentCompany ? state.currentCompany.short_name : '未选择公司'
  }
}
